/**
 * Returns the trimmed value and handles nbsp characters.
 * mainly to remove the 'nbsp;' from the processing text i.e. 'Processing Video... \n &nbsp; '
 */
function removeExtraSpaces(content: string): string {
  return content.replaceAll(/&nbsp;|\u00A0/g, ' ');
}

export { removeExtraSpaces };
